import { render, staticRenderFns } from "./ProductSingleSelectComponentDialog.vue?vue&type=template&id=53c1e866&"
import script from "./ProductSingleSelectComponentDialog.vue?vue&type=script&lang=js&"
export * from "./ProductSingleSelectComponentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports